import React from "react";
import "../styles/hero.css";

import heroImage from "../assets/home.png";
import logoAI from "../assets/Engineered with advanced AI.svg";
import logoHuman from "../assets/Designed for humans.svg";
import questionIcon from "../assets/Question.svg";

const Hero = () => {
  return (
    <section className="hero-wrapper">
      <div className="hero">

        {/* LEFT CONTENT */}
        <div className="hero-left">

          <span className="hero-badge">
            <img src={questionIcon} alt="icon" />
            AI-Powered Service Excellence
          </span>

          <h1 className="hero-title">
            A Smarter Way to Care <br />
            for Every <span>Vehicle</span>
          </h1>

          <p className="hero-subtitle">
            Precision. Clarity. Effortless Intelligence.
          </p>

          <p className="hero-description">
            We built a new kind of service platform—one that sees the road
            ahead, speaks with understanding, and simplifies every step of
            the automotive and motorbike experience.
          </p>

          <div className="hero-actions">
            <button className="btn-primary">Request Demo →</button>
            <button className="btn-secondary">Explore Features</button>
          </div>

          <div className="hero-features">
            <div className="hero-feature">
              <img src={logoAI} alt="icon" />
              Engineered with advanced AI
            </div>
            <div className="hero-feature">
              <img src={logoHuman} alt="icon" />
              Designed for humans
            </div>
          </div>

        </div>

        {/* RIGHT IMAGE */}
        <div className="hero-right">
          <img src={heroImage} alt="Automitra Hero" />
        </div>

      </div>
    </section>
  );
};

export default Hero;
